import DeletePayslip from "@/v2/api/payslip/Delete";
import DeleteButton from "../general/Delete";

export default function PayslipDeleteButton({
  id,
  isInside = false,
}: {
  id: string;
  isInside?: boolean;
}) {
  return (
    <DeleteButton
      id={id}
      queryKey={["payslip"]}
      deleteFn={DeletePayslip}
      title="Delete Payslip"
      description="Are you sure you want to delete this payslip record? This action cannot be undone. Click delete to confirm."
      successTitle="Payslip Deleted Successfully"
      isInside={isInside}
    />
  );
}
